import { PlaceHolder } from './PlaceHolder';
import { Container } from './Container';

export const AppShell = { PlaceHolder, Container };
